import classnames from 'classnames';

export interface IFormRowProps {
    children: React.ReactNode;
    className?: string;
    hasErrors?: boolean;
    hasStackedFormGroups?: boolean;
    row?: boolean;
}
export function FormRow(props: IFormRowProps) {
    return (
        <div
            className={classnames(
                props.row ? 'row' : 'form-row',
                props.hasStackedFormGroups ? 'layout end' : '',
                props.hasErrors ? ' has-danger' : '',
                props.className || ''
            )}
        >
            {props.children}
        </div>
    );
}
